if (!customElements.get('plan-picker')) {
  class PlanPicker extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-plan-option-buy]');
      if (!this.button) return;

      this.onClick = this.onClick.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    onPageShow() {
      this.setLoading(false);
      this.setError('');
    }

    get rootUrl() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.endsWith('/') ? root : `${root}/`;
    }

    get cartAddUrl() {
      return (window.routes && window.routes.cart_add_url) || `${this.rootUrl}cart/add`;
    }

    get cart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    onClick(event) {
      event.preventDefault();
      if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
      this.addToCart();
    }

    addToCart() {
      const variantId = Number(this.button.dataset.variantId);
      if (!variantId) {
        this.setError('This plan is not available yet. Please choose another one.');
        return;
      }

      const item = { id: variantId, quantity: Number(this.button.dataset.quantity) || 1 };
      const sellingPlan = this.button.dataset.sellingPlanId;
      if (sellingPlan) item.selling_plan = Number(sellingPlan);

      const cart = this.cart;
      const body = { items: [item] };

      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      this.setLoading(true);
      this.setError('');

      fetch(this.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.setLoading(false);
            this.setError(response.description || response.message);
            return;
          }

          this.setLoading(false);

          if (!cart) {
            window.location.href = `${this.rootUrl}cart`;
            return;
          }

          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'plan-picker',
              productVariantId: item.id,
              cartData: response,
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.setLoading(false);
          this.setError('Something went wrong. Please try again.');
        });
    }

    setLoading(isLoading) {
      this.button.classList.toggle('loading', isLoading);
      this.button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      const spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !isLoading);
    }

    setError(message) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      const el = wrapper && wrapper.querySelector('.product-form__error-message');
      if (!wrapper || !el) return;
      wrapper.hidden = !message;
      el.textContent = message || '';
    }
  }

  customElements.define('plan-picker', PlanPicker);
}
